import {Icon, Typography} from '@ezcater/tapas';
import {faInfoCircle, faTriangleExclamation} from '@fortawesome/pro-regular-svg-icons';
import {twJoin, twMerge} from 'tailwind-merge';

type InfoBannerProps = {
  className?: string;
  'data-testid'?: string;
  role?: 'alert';
  text: string;
  variant?: 'info' | 'warning';
};

const variantStyles = {
  info: {
    backgroundColor: 'bg-blue-50',
    iconColor: 'text-blue-500',
    icon: faInfoCircle,
  },
  warning: {
    backgroundColor: 'bg-pomegranate-50',
    iconColor: 'text-pomegranate-400',
    icon: faTriangleExclamation,
  },
};

// Style variant change: experiment ezx578 - Precise Address Nudge.
// Remove the variant and rename the component after the experiment completion if necessary.
// Or it can be a Banner and not an InfoBanner component.
const InfoBanner: React.FC<InfoBannerProps> = ({
  className,
  'data-testid': dataTestId,
  role,
  text,
  variant = 'info',
}) => {
  return (
    <div
      className={twMerge(
        'flex w-0 min-w-full rounded-lg p-4',
        variantStyles[variant].backgroundColor,
        className,
      )}
      data-testid={dataTestId}
      role={role}
    >
      <div className="shrink-0 pr-2">
        <Icon
          aria-hidden
          className={twJoin('h-5 w-5', variantStyles[variant].iconColor)}
          icon={variantStyles[variant].icon}
        />
      </div>
      <Typography className="min-w-0" variant="body-sm">
        {text}
      </Typography>
    </div>
  );
};

export default InfoBanner;
